<template>
  <div class="container-table">
    <q-card-section>
      <q-table
        data-cy="plan-instrumeto-table"
        :title="title"
        :data="planes"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns"
      >
        <template
v-slot:body-cell-estado="props"
          ><q-td data-cy="estado" :props="props" key="estado">{{
            props.selected ? 'Visible' : ''
          }}</q-td></template
        >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fase="props">
          <q-td key="fase" :props="props">
            <QChipFases :value="props.row.fase"/>
          </q-td>
        </template>
        <template v-slot:body-cell-periodoVigencia="props">
          <q-td key="periodoVigencia" :props="props">
            {{ props.row.periodoVigencia }}
          </q-td>
        </template>
        <template v-slot:body-cell-obsevaciones="props">
          <q-td key="observaciones" :props="props">
            {{ props.row.observaciones }}
          </q-td>
        </template>

        <template v-slot:body-cell-planAdjuntoNombre="props">
          <q-td key="planAdjuntoNombre" :props="props">
            {{ props.row.planAdjuntoNombre }}
          </q-td>
        </template>

        <template v-slot:body-cell-planAdjuntoUrl="props">
          <q-td key="planAdjuntoUrl" :props="props">
            <a v-if="props.row.planAdjuntoUrl" :href="props.row.planAdjuntoUrl" download target="_blank">
              <q-icon :name="'img:' + require('@/assets/img/file-download-black-24-dp.svg')"></q-icon>
            </a>
          </q-td>
        </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              data-cy="bDeleteCity"
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      dataCy="delete-plan"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar el plan? ${rowSelectedtoDelete.nombre}`
      "
      @save="deletePlan()"
    />
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import Message from '@/components/shared/mixins/Message.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    QChipFases,
    DialogDelete
  },
  props: {
    isLoading: Boolean,
    planes: Array,
    visibleColumns: {
      type: Array,
      default: () => ['nombre', 'fase', 'periodoVigencia', 'observaciones', 'planAdjuntoNombre', 'planAdjuntoUrl', 'eliminar']
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  mixins: [Loading, Message],
  computed: {
    ...mapGetters({
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      columns: [
        {
          name: 'nombre',
          label: 'Nombre',
          align: 'left',
          field: 'nombre',
          sortable: true
        },
        {
          name: 'fase',
          label: 'Fase',
          align: 'left',
          field: 'fase',
          sortable: true
        },
        {
          name: 'periodoVigencia',
          label: 'Periodo Vigencia',
          align: 'left',
          field: 'periodoVigencia',
          sortable: true
        },
        {
          name: 'observaciones',
          label: 'Observaciones',
          align: 'left',
          field: 'observaciones',
          sortable: true
        },
        {
          name: 'planAdjuntoNombre',
          label: 'Archivo adjunto',
          align: 'left',
          field: 'planAdjuntoNombre',
          sortable: true
        },
        {
          name: 'planAdjuntoUrl',
          label: '',
          align: 'left',
          field: 'planAdjuntoUrl',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  created () {
    if (this.isOnlyAccess) {
      this.visibleColumns.pop();
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$eventHub.$on('saveNewPlan', newPlan => {
        if (this.planes.length + 1 <= 5) {
          this.planes.push(newPlan);
        } else {
          this.showError('No se pueden añadir más de 5 planes');
        }
        this.$eventHub.$emit('dirtyForm');
      });
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('saveNewPlan');
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deletePlan () {
      // obtenemos indice
      const index = this.planes.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.planes.splice(index, 1);
      this.showDialogDelete = false;
      this.$eventHub.$emit('dirtyForm');
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
}
</style>
